import { AxiosStatic } from "axios";
import { TSendNotificationPayload } from "../types";
import { SEND_TIMEOUT_MS } from "../constants";

const bulkPostNotifications =
  (serverURL: string, appAxios: AxiosStatic, token: string) =>
  async (data: TSendNotificationPayload[]): Promise<void> => {
    await appAxios.post(
      `${serverURL}/admin/bulk-notifications`,
      {
        data,
      },
      {
        timeout: SEND_TIMEOUT_MS,
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
  };

export default bulkPostNotifications;
